<div>
    <span class="netta">netta</span><sup><small class="mr">®️</small></sup> <small class="score"> Score</small>
</div>